goog.provide('el8.util.amplitude.schedulerHelpers');

goog.require('el8.service.tz');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.datecompare');

/**
 * Log when a create new appointment dialog is opened via various flows of scheduler
 * 
 * @param {string} source the name of the source of the event
 */
el8.util.amplitude.logOpenCreateNewApptDialog = function(source) {
    el8.util.amplitude.logEvent('open new appointment dialog', {
        source: source
    });
};

/**
 * Logs when a new patient appointment is created
 * 
 * @param {object} appointment appointment el8 model item
 */
el8.util.amplitude.logCreateNewAppt = function(appointment) {
    el8.util.amplitude.logEvent('create new appointment', {
        'appointment id': appointment.getId(), 
        'telehealth link': el8.util.string.containsUrl(appointment.getTelehealthInstructions()),
        'telehealth text': appointment.getTelehealthInstructions() !== ''
    });
}

/**
 * Logs when a patient appointment is edited
 * 
 * @param {object} appointment appointment el8 model item
 * @param {object} opts options
 * @param {boolean} opts.isTelehealthInstructionsModified appointment telehealthInstructions is modified
 */
el8.util.amplitude.logEditAppt = function(appointment, opts) {
    var isTelehealthInstructionsModified = Boolean(opts && opts.isTelehealthInstructionsModified);

    var minutesDiff = el8.util.datecompare.minutesBetween(el8.service.tz.now(), appointment.getApptTime());
    el8.util.amplitude.logEvent('update appointment', {
        'appointment id': appointment.getId(),
        'minutes from appointment': minutesDiff,
        'telehealth link': el8.util.string.containsUrl(appointment.getTelehealthInstructions()),
        'telehealth text': appointment.getTelehealthInstructions() !== '',
        'telehealth text modified': isTelehealthInstructionsModified
    });
}